/**
 * Norwegian price formatting: space thousands separator, "kr" suffix.
 * Input is minor units (øre), as stored in the DB.
 */
export function formatKr(minor: number | null): string {
	if (minor == null) return "—";
	const kr = Math.round(minor / 100);
	return `${kr.toLocaleString("nb-NO").replace(/ /g, " ")} kr`;
}

/** A price in the shelf-tag face: condensed, tabular, never mono. */
export function Money({ minor, className = "" }: { minor: number | null; className?: string }) {
	return <span className={`font-semibold font-tag ${className}`}>{formatKr(minor)}</span>;
}
